import { createContext } from 'react'

const mistreatmentContext = createContext()

export default mistreatmentContext
